import type { MessageExamples } from '../types'

export default {
  tips: [
    'Si hei, hold tonen som høflig.',
    'Skriv med dine egne ord, ikke kopier de angitte tekstene, på denne måten vil forespørselen din bli tatt mer hensyn til.',
    'Nevn hvorfor det er viktig for deg at de utfaser turbokylling så fort som mulig.',
    'Oppgi gjerne navn, addresse og telefonnummer. Det vil vise at du er en ekte person.',
    // 'I tittelen på brevet og i brevet, nevner du navnet på Seimas-medlemmet du henvender deg til.',
    // 'Nevn at snart må et medlem av Seimas stemme om forbud mot pelsfarmer. Be ham stemme mot.',
    // 'Nevn hvorfor det er viktig for deg at dette medlem av Seimas stemmer for forslaget om å utsette forbudet mot pelsdyrfarmer',
  ],
  messages: [
    'Hei, jeg er en kunde som er opptatt av dyrevelferd. Jeg håper dere vurderer å slutte med turbokylling og heller velge mer dyrevennlige alternativer. Har dere noen planer om dette?',
    'Jeg handler bevisst, og det betyr at jeg unngår bedrifter som selger turbokylling. Når vil dere ta ansvar og slutte å støtte denne praksisen?',

    'Turbokyllinger lider fra de klekkes til de slaktes. Jeg ønsker å handle hos dere, men ikke så lenge dere selger produkter som bidrar til denne lidelsen.',

    'Mange andre aktører har allerede droppet turbokylling – hvorfor henger dere fortsatt etter? Dyrevelferd burde være en prioritet for alle seriøse bedrifter.',

    'Kyllinger i industrien blir avlet for å vokse ekstremt raskt, noe som fører til smerte og helseproblemer. Dere har makten til å endre dette ved å velge bedre alternativer.',

    'Det finnes mer bærekraftige og etiske valg enn turbokylling. Når vil dere følge i fotsporene til de som allerede har gjort det riktige valget?',

    'Som kunde ønsker jeg at bedriftene jeg handler hos tar ansvar. Vil dere gjøre som flere andre og slutte med turbokylling?',

    'Turbokylling-industrien er basert på unødvendig lidelse. Hvis dere virkelig bryr dere om dyrevelferd, hvorfor selger dere fortsatt disse produktene?',

    'Mange forbrukere ønsker et mer etisk matvalg. Ved å fortsette å selge turbokylling viser dere at profitt er viktigere enn dyrevelferd. Er det virkelig slik dere vil fremstå?',

    'Dere har et valg: Fortsette å støtte en grusom industri eller ta ansvar og velge dyrevennlige alternativer. Hva velger dere?',

    'Kyllinger i intens oppdrett får aldri oppleve naturlig atferd. Jeg håper dere snart tar et standpunkt mot denne urettferdige behandlingen.',
  ],
  // emails: [
  //   {
  //     subject: 'Welcome to our platform',
  //     body: 'Kyllingene dere selger har hatt fryktelige leveforhold. Ved å selge turbokylling støtter dere unødvendig lidelse for dyrene.',
  //   },
  //   {
  //     subject: 'Welcome to our platform',
  //     body: 'Dere reklamer for og viser et glansbilde av kyllinger, men bilder fra turbokylling-farmer og vitenskaplige studier beviser at dyrene ikke engang har mulighet til å dekke sine grunnleggende behov.',
  //   },
  //   {
  //     subject: 'Welcome to our platform',
  //     body: 'Kyllinger som vokser sakte har et mye bedre liv. Ved å selge turbokylling tjener dere penger på en grusom praksis.',
  //   },
  //   {
  //     subject: 'Welcome to our platform',
  //     body: 'Rema 1000 og Oda har allerede sluttet å selge turbokylling. Det er ingen grunn til at det ikke skulle være mulig for dere også.',
  //   },
  // ],
} as MessageExamples
